import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import styled from "styled-components";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import _ from "lodash";
import { makeStyles } from "@mui/styles";
import ImageList from "@mui/material/ImageList";
import Tooltip from "@mui/material/Tooltip";
import Edit from "@mui/icons-material/Edit";
import Chip from "@mui/material/Chip";
import { ActionContext } from "context/ActionContext";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import UserService from "services/UserService";
import { putAction, getAction, getSite } from "services/ConfigServices";
import { action as actionVar } from "variables/action";
import {
  energyType,
  engineeringstudyedelementsData,
  targetedenergyList,
  savingstypeData,
} from "variables/lists/action";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import {
  AutocompleteMultiselectCheckbox,
  CustomSelect,
  CustomSwitch,
  DateInput,
  FloatInput,
  IntInput,
  LocalizationAutocomplete,
  TextInput,
} from "components/Input/Index.js";
import EditButton from "components/CustomButtons/EditButton";
import RTTargetFluid from "./Fluid/RTTargetFluid";

const SubTitle = styled.div`
  margin: ${(props) =>
    props.first ? "1rem 0rem 0.1rem 1.4rem" : "1.4rem 0rem 0.1rem 1.4rem"};
  font-size: 1.2rem;
  font-weight: 500;
  text-underline-position: under;
  text-decoration: underline;
  text-decoration-color: #91c73c;
`;

export default function EngineeringstudyImpactEdit({ apiData, params }) {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const actionplanupdate = permis.includes("actionplan_update");
  const appContext = useContext(ActionContext);
  const { action, setAction } = appContext;

  const [newImpact, setNewImpact] = useState({});
  const [groups, setGroups] = useState();

  console.log(newImpact, action, params);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNewImpact((prevState) => ({
      ...prevState,
      [params]: { ...prevState.impact, [name]: value },
    }));
  };

  useEffect(() => {
    console.log("action");
    setNewImpact(action?.parameters || {});
    setGroups(action?.parameters?.[params]?.groups || []);
  }, [action?.parameters?.[params]]);

  const urlPlanAction = getAction(action.id);

  let url = putAction(action.id);

  const handleSubmit = (event) => {
    createActionImpact(event);
  };

  const createActionImpact = async (event) => {
    console.log({ ...newImpact, impact: { ...newImpact.impact, groups } });

    const groupsIsAnArray = Array.isArray(groups);
    if (groupsIsAnArray) {
      axios
        .put(
          url,
          { ...newImpact, impact: { ...newImpact.impact, groups } },
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
            },
          }
        )
        .then((res) => {
          console.log(res);
          if (res.status == 200) {
            setNotification("success", "Action modifiée");
            getActionData();
          } else setNotification("error", "Une erreur est survenue");
        })
        .catch((error) => {
          setNotification("error", "Une erreur est survenue");
          //setLoading(false);
        });
    } else {
      axios
        .put(
          url,
          {
            ...newImpact,
            impact: { ...newImpact.impact, groups: [groups] },
          },
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
              'Content-Type': "application/json; charset=utf-8",
            },
          }
        )
        .then((res) => {
          console.log(res);
          if (res.status == 200) {
            setNotification("success", "Action modifiée");
            getActionData();
          } else setNotification("error", "Une erreur est survenue");
        })
        .catch((error) => {
          setNotification("error", "Une erreur est survenue");
          //setLoading(false);
        });
    }
  };

  const getActionData = () => {
    axios
      .get(urlPlanAction, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      })
      .then((response) => {
        console.log(response.data);
        setAction(response.data || []);
        setNewImpact(response.data.parameters || {});
      });
  };

  const handleEngineeringstudyedelementsChange = (e) => {
    const { name, value } = e.target;

    console.log(name, value);
    if (value == "energy") {
      setAction((prevState) => ({
        ...prevState,
        parameters: {
          ...prevState.parameters,
          impact: {
            ...prevState.impact,
            [name]: value,
            equipments: [],
            walls: [],
          },
        },
      }));
    } else if (value == "equipments") {
      setAction((prevState) => ({
        ...prevState,
        parameters: {
          ...prevState.parameters,
          impact: { ...prevState.impact, [name]: value, energy: [], walls: [] },
        },
      }));
    } else if (value == "walls") {
      setAction((prevState) => ({
        ...prevState,
        parameters: {
          ...prevState.parameters,
          impact: {
            ...prevState.impact,
            [name]: value,
            equipments: [],
            energy: [],
          },
        },
      }));
    } else {
      setAction((prevState) => ({
        ...prevState,
        parameters: {
          ...prevState.parameters,
          impact: { ...prevState.impact, [name]: value },
        },
      }));
    }
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  let engineeringstudyedelements =
    action.parameters?.impact?.engineeringstudyedelements;

  return (
    <>
      <SubTitle first>Paramètres</SubTitle>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12} lg={12}>
          <CustomSelect
            inputTitle={actionVar.impact.engineeringstudyedelements}
            selectValue={
              action.parameters?.impact?.["engineeringstudyedelements"] || ""
            }
            handleSelectValueChange={handleEngineeringstudyedelementsChange}
            data={engineeringstudyedelementsData}
            name="engineeringstudyedelements"
            disabled={!actionplanupdate}
          />
        </GridItem>
        {engineeringstudyedelements !== "others" && (
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <div
              style={{
                border: "0.099rem solid rgba(0, 0, 0, .22)",
                borderRadius: "0.3rem",
                padding: "0 0.6rem",
                margin: "1rem 0.5rem 0rem",
              }}
            >
              <RTTargetFluid />
            </div>
          </GridItem>
        )}
      </GridContainer>

      <GridContainer>
        <GridItem xs={12} sm={12} md={12} lg={12}>
          <TextInput
            inputTitle={actionVar[params].observations}
            textInput={newImpact?.[params]?.observations}
            handleTextInputChange={handleChange}
            name="observations"
            disabled={!actionplanupdate}
          />
          <TextInput
            inputTitle={actionVar[params].comments}
            textInput={newImpact?.[params]?.comments}
            handleTextInputChange={handleChange}
            name="comments"
            disabled={!actionplanupdate}
          />
        </GridItem>
      </GridContainer>
      <SubTitle>Impacts</SubTitle>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12} lg={12}>
          <TextInput
            inputTitle={actionVar[params].expecteddeliverables}
            textInput={newImpact?.[params]?.expecteddeliverables}
            handleTextInputChange={handleChange}
            name="expecteddeliverables"
            disabled={!actionplanupdate}
          />
        </GridItem>
      </GridContainer>
      {actionplanupdate && (
        <GridContainer style={{marginTop: "15px",marginLeft: "8px"}}>
          <GridItem xs={12} sm={6} md={7} lg={7}>
            <EditButton handleSubmit={handleSubmit}>Modifier</EditButton>
          </GridItem>
        </GridContainer>
      )}
    </>
  );
}
